export interface EjercicioContable {
  idEjercicio: number;
  anio: number;
  estado: string;
  periodos?: PeriodoContable[];
  configuracion?: any;
}

export interface PeriodoContable {
  idPeriodo: number;
  idEjercicio: number;
  numeroPeriodo: number;
  estado: string;
  fechaInicio: string | null;
  fechaFin: string | null;
}

export const PERIODO_LABELS: Record<number, string> = {
  0: 'Apertura',
  1: 'Enero',
  2: 'Febrero',
  3: 'Marzo',
  4: 'Abril',
  5: 'Mayo',
  6: 'Junio',
  7: 'Julio',
  8: 'Agosto',
  9: 'Septiembre',
  10: 'Octubre',
  11: 'Noviembre',
  12: 'Diciembre',
  13: 'Cierre Resultados',
  14: 'Cierre Balance',
};
